import template from './riccardo-offer-list.html.twig';

const { Criteria } = Shopware.Data;

export default {
    template,

    inject: ['repositoryFactory'],

    data() {
        return {
            offers: null,
            isLoading: false,
            total: 0,
        };
    },

    metaInfo() {
        return { title: this.$createTitle() };
    },

    computed: {
        offerRepository() {
            return this.repositoryFactory.create('riccardo_offer');
        },

        columns() {
            return [
                { property: 'active', label: this.$t('riccardo-offer.list.columnActive'), width: '90px', align: 'center' },
                { property: 'name', label: this.$t('riccardo-offer.list.columnName'), routerLink: 'riccardo.offer.detail', primary: true },
                { property: 'badge', label: this.$t('riccardo-offer.list.columnBadge'), width: '100px' },
                { property: 'code', label: this.$t('riccardo-offer.list.columnCode') },
                { property: 'audience', label: this.$t('riccardo-offer.list.columnAudience') },
                { property: 'durationHours', label: this.$t('riccardo-offer.list.columnValidity') },
                { property: 'priority', label: this.$t('riccardo-offer.list.columnPriority'), width: '110px' },
            ];
        },
    },

    created() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;
            const criteria = new Criteria(1, 50);
            criteria.addSorting(Criteria.sort('priority', 'DESC'));
            criteria.addSorting(Criteria.sort('createdAt', 'DESC'));

            return this.offerRepository.search(criteria).then((result) => {
                this.offers = result;
                this.total = result.total;
            }).finally(() => {
                this.isLoading = false;
            });
        },

        formatValidity(offer) {
            if (offer.durationHours) {
                return this.$t('riccardo-offer.list.personalCountdown', { hours: offer.durationHours });
            }
            if (offer.endsAt) {
                return new Date(offer.endsAt).toLocaleString('de-DE');
            }
            return '–';
        },
    },
};
